import React, {useState, useEffect} from 'react';
import axios from '@app/lib/axios';

import Modal from 'react-bootstrap/Modal';

import * as Constant from '@app/Constant.js';

import AppInfoForm from './AppInfoForm.js';

const AppInfoModal = ({show, onHide, tagList, platformList, appId, dataCallback}) => {
    const [doSomething, setDoSomething] = useState(false);
    const [appData, setAppData] = useState(null);

    useEffect(() => {
        setDoSomething(true);
        if(show && appId) {
            axios({
              method: "get",
              url: Constant.API_DOMAIN+"/api/app_version/current/"+appId
            })
            .then(result => {
                const appData = result.data;

                if(appData.charger) {
                    if(appData.charger.P) {
                        let planers = JSON.parse(JSON.stringify(appData.charger.P));
                        appData.charger.P_desc = planers.flatMap(p => p.desc);;
                    }
                    if(appData.charger.D) {
                        let developers = JSON.parse(JSON.stringify(appData.charger.D));
                        appData.charger.D_desc = developers.flatMap(d => d.desc);
                    }
                }

                setAppData({
                    isUpdate: 1,
                    ...appData.app,
                    charger_p: appData.charger.P_desc ? appData.charger.P_desc.join(', ') : '',
                    charger_d: appData.charger.D_desc ? appData.charger.D_desc.join(', ') : '',
                    platforms: appData.platformList.flatMap(p => p.platform_id)
                });
                setDoSomething(false);
              })
            .catch(error => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                setAppData(null);
                setDoSomething(false);
            });
        } else {
            setAppData(null);
            setDoSomething(false);
        }
        
        return () => {};
    }, [show, appId]);

    return (
        <Modal
            size='lg'
            show={show}
            onHide={onHide}
            aria-labelledby="example-custom-modal-styling-title"
        >
            <Modal.Header closeButton>
                <Modal.Title id="example-custom-modal-styling-title">
                    앱 정보 {appId && appData ? '수정' : '등록'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <AppInfoForm
                    data={appData}
                    tagList={tagList}
                    platformList={platformList}
                    dataCallback={appId=>{
                        dataCallback(appId);
                        onHide();
                    }}
                />
            </Modal.Body>
        </Modal>
    );
}

export default AppInfoModal;